import { render, staticRenderFns } from "./MiscNotAuthorized.vue?vue&type=template&id=78c720e0"
import script from "./MiscNotAuthorized.vue?vue&type=script&lang=js"
export * from "./MiscNotAuthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports